import currency from 'currency.js';
import { Controller, useFormContext } from 'react-hook-form';

import { CurrencyInput } from 'src/common/CurrencyInput';
import type { InvoiceRead } from 'src/common/external/bambi-api/bambiApi';

import { INVOICE_LINE_ITEM_TRIP_ID_MARKER } from '../constants';
import type {
  InvoiceNestedLineItemWithId} from '../InvoiceFormContext';
import {
  useInvoiceFormContext,
} from '../InvoiceFormContext';
import { PriceEditCellPercentPopover } from './PriceEditCellPercentPopover';

interface PriceEditCellProps {
  lineItem: InvoiceNestedLineItemWithId;
}
export function PriceEditCell({ lineItem }: PriceEditCellProps) {
  const { control } = useFormContext<InvoiceRead>();
  const { findLineItemIndex } = useInvoiceFormContext();
  const actualIndex = findLineItemIndex(lineItem);

  const isInvoiceAdjustmentLineItem = lineItem.trip.id.endsWith(
    INVOICE_LINE_ITEM_TRIP_ID_MARKER
  );

  return (
    <Controller
      control={control}
      name={`line_items.${actualIndex}.amount_cents`}
      render={({ field }) => {
        return (
          <div className="flex flex-row gap-1">
            <CurrencyInput
              data-testid="price-input"
              className="w-24"
              value={field.value}
              onChange={(e) => {
                const cents = currency(e.target.value).multiply(100).value;
                field.onChange(cents);
              }}
              allowNegative
            />
            {isInvoiceAdjustmentLineItem ? (
              <PriceEditCellPercentPopover
                onChange={field.onChange}
                gatherLineItemsUntilId={lineItem.trip.id}
              />
            ) : null}
          </div>
        );
      }}
    />
  );
}
